<template>
  <v-app style="background-color: #f8f9fb">
    <v-container
      style="background-color: #eee"
      id="blacklist"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-block-helper"
            title="Blacklist"
            color="rgb(71 130 180)"
            style="
              margin-top: 60px !important;
              padding-top: 10px !important;
              min-height: 70vh !important;
            "
            class="px-5 py-0"
          >
            <v-tabs v-model="abaAtiva" background-color="transparent" class="mt-4">
              <v-tab>Cadastrar</v-tab>
              <v-tab>Consultar</v-tab>
            </v-tabs>

            <v-tabs-items v-model="abaAtiva" class="mt-4">
              <!-- Cadastro -->
              <v-tab-item>
                <v-form ref="formCadastro" v-model="cadastroValido" lazy-validation>
                  <v-row class="mt-2">
                    <v-col cols="12" sm="6" md="3">
                      <v-select
                        v-model="cadastro.tipo"
                        :items="tiposBlacklist"
                        item-text="label"
                        item-value="value"
                        label="Tipo"
                        dense
                        solo-inverted
                        :rules="[obrigatorio]"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="cadastro.valor"
                        label="Valor"
                        dense
                        solo-inverted
                        :hint="hintValor"
                        persistent-hint
                        :rules="[obrigatorio]"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-text-field
                        v-model="cadastro.idCliente"
                        label="ID Cliente (opcional)"
                        type="number"
                        dense
                        solo-inverted
                      />
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        v-model="cadastro.motivo"
                        label="Motivo (opcional)"
                        dense
                        solo-inverted
                        maxlength="255"
                      />
                    </v-col>
                  </v-row>
                  <v-card-actions class="d-flex justify-end pb-4">
                    <v-btn text @click="limparCadastro">
                      <v-icon left>mdi-broom</v-icon>
                      Limpar
                    </v-btn>
                    <v-btn
                      color="primary"
                      :loading="salvando"
                      :disabled="!cadastroValido"
                      @click="salvarItem"
                    >
                      <v-icon left>mdi-content-save</v-icon>
                      Cadastrar
                    </v-btn>
                  </v-card-actions>
                </v-form>

                <div class="d-flex align-center justify-space-between mt-2 mb-2">
                  <p class="text-subtitle-2 mb-0">Últimos cadastrados</p>
                  <v-btn
                    color="primary"
                    outlined
                    small
                    :loading="carregandoUltimos"
                    @click="carregarUltimos"
                  >
                    <v-icon left>mdi-refresh</v-icon>
                    Atualizar
                  </v-btn>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="listaUltimos"
                  :loading="carregandoUltimos"
                  :items-per-page="25"
                  items-per-page-text="Linhas por página"
                  class="elevation-0"
                  no-data-text="Nenhum registro na blacklist"
                >
                  <template v-slot:item.tipo="{ item }">
                    {{ labelTipo(item.tipo) }}
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-chip small :color="statusCor(item)" text-color="white">
                      {{ statusLabel(item) }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-tab-item>

              <!-- Consulta -->
              <v-tab-item>
                <v-radio-group
                  v-model="modoConsulta"
                  row
                  class="mt-2"
                  hide-details
                >
                  <v-radio label="Por tipo e valor" value="tipoValor" />
                  <v-radio label="Por ID do cliente" value="cliente" />
                </v-radio-group>

                <v-form ref="formConsulta" lazy-validation>
                  <v-row v-if="modoConsulta === 'tipoValor'" class="mt-2">
                    <v-col cols="12" sm="6" md="3">
                      <v-select
                        v-model="consulta.tipo"
                        :items="tiposBlacklist"
                        item-text="label"
                        item-value="value"
                        label="Tipo"
                        dense
                        solo-inverted
                        :rules="[obrigatorio]"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="5">
                      <v-text-field
                        v-model="consulta.valor"
                        label="Valor"
                        dense
                        solo-inverted
                        :rules="[obrigatorio]"
                      />
                    </v-col>
                  </v-row>
                  <v-row v-else class="mt-2">
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="consulta.idCliente"
                        label="ID Cliente"
                        type="number"
                        dense
                        solo-inverted
                        :rules="[obrigatorio]"
                      />
                    </v-col>
                  </v-row>
                  <v-card-actions class="d-flex justify-end pb-2">
                    <v-btn
                      color="warning"
                      outlined
                      class="mr-2"
                      :disabled="!registroSelecionado"
                      @click="abrirDialogStatus"
                    >
                      <v-icon left>mdi-swap-horizontal</v-icon>
                      Alterar status
                    </v-btn>
                    <v-btn
                      color="primary"
                      :loading="consultando"
                      @click="executarConsulta"
                    >
                      <v-icon left>mdi-magnify</v-icon>
                      Consultar
                    </v-btn>
                  </v-card-actions>
                </v-form>

                <p class="text-subtitle-2 mb-2 mt-2">
                  Resultado da consulta
                  <span v-if="registroSelecionado" class="text-caption grey--text">
                    — selecionado: #{{ registroSelecionado.id }}
                  </span>
                </p>
                <v-data-table
                  :headers="headersConsulta"
                  :items="listaConsulta"
                  :loading="consultando"
                  :items-per-page="20"
                  item-key="id"
                  items-per-page-text="Linhas por página"
                  class="elevation-0"
                  no-data-text="Nenhum registro encontrado"
                  @click:row="selecionarRegistro"
                  :item-class="classeLinhaSelecionada"
                >
                  <template v-slot:item.tipo="{ item }">
                    {{ labelTipo(item.tipo) }}
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-chip small :color="statusCor(item)" text-color="white">
                      {{ statusLabel(item) }}
                    </v-chip>
                  </template>
                  <template v-slot:item.acoes="{ item }">
                    <v-btn
                      icon
                      small
                      color="warning"
                      title="Alterar status"
                      @click.stop="abrirDialogStatusItem(item)"
                    >
                      <v-icon small>mdi-swap-horizontal</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs-items>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialogStatus" max-width="480" persistent>
      <v-card>
        <v-card-title class="headline">Alterar status</v-card-title>
        <v-card-text v-if="registroStatus">
          <p class="mb-1">
            <strong>ID:</strong> {{ registroStatus.id }}
          </p>
          <p class="mb-1">
            <strong>Tipo:</strong> {{ labelTipo(registroStatus.tipo) }}
          </p>
          <p class="mb-3">
            <strong>Valor:</strong> {{ registroStatus.valor }}
          </p>
          <v-switch
            v-model="statusAtivo"
            :label="statusAtivo ? 'Ativo na blacklist' : 'Inativo (exclusão lógica)'"
            color="success"
            hide-details
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="fecharDialogStatus">Cancelar</v-btn>
          <v-btn
            color="primary"
            :loading="alterandoStatus"
            @click="confirmarAlterarStatus"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="4000">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import blacklist from "../../services/blacklist";

const TIPOS = [
  { value: "cliente", label: "Cliente" },
  { value: "contrato", label: "Contrato" },
  { value: "cpf", label: "CPF" },
  { value: "telefone", label: "Telefone" },
  { value: "email", label: "E-mail" },
];

export default {
  name: "Blacklist",

  data() {
    return {
      abaAtiva: 0,
      modoConsulta: "tipoValor",
      cadastroValido: false,
      salvando: false,
      consultando: false,
      carregandoUltimos: false,
      alterandoStatus: false,
      dialogStatus: false,
      registroSelecionado: null,
      registroStatus: null,
      statusAtivo: true,
      tiposBlacklist: TIPOS,
      cadastro: {
        tipo: null,
        valor: "",
        idCliente: "",
        motivo: "",
      },
      consulta: {
        tipo: null,
        valor: "",
        idCliente: "",
      },
      listaUltimos: [],
      listaConsulta: [],
      headers: [
        { text: "ID", value: "id", width: "80px" },
        { text: "Tipo", value: "tipo" },
        { text: "Valor", value: "valor" },
        { text: "ID Cliente", value: "idCliente" },
        { text: "Motivo", value: "motivo" },
        { text: "Inclusão", value: "dataInclusao" },
        { text: "Status", value: "status", sortable: false },
      ],
      headersConsulta: [
        { text: "ID", value: "id", width: "80px" },
        { text: "Tipo", value: "tipo" },
        { text: "Valor", value: "valor" },
        { text: "ID Cliente", value: "idCliente" },
        { text: "Motivo", value: "motivo" },
        { text: "Inclusão", value: "dataInclusao" },
        { text: "Status", value: "status", sortable: false },
        { text: "Ações", value: "acoes", sortable: false, width: "90px" },
      ],
      snackbar: {
        show: false,
        text: "",
        color: "success",
      },
    };
  },

  computed: {
    hintValor() {
      if (this.cadastro.tipo === "cpf") {
        return "Prefira informar apenas números para evitar duplicatas.";
      }
      if (this.cadastro.tipo === "email") {
        return "Informe o e-mail completo.";
      }
      return "";
    },
  },

  mounted() {
    this.carregarUltimos();
  },

  methods: {
    obrigatorio(v) {
      return (v != null && String(v).trim() !== "") || "Campo obrigatório";
    },

    labelTipo(tipo) {
      const item = TIPOS.find((t) => t.value === tipo);
      return item ? item.label : tipo;
    },

    statusLabel(item) {
      return item.dataExclusao ? "Excluído" : "Ativo";
    },

    statusCor(item) {
      return item.dataExclusao ? "grey" : "green darken-1";
    },

    exibirMensagem(text, color = "success") {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },

    limparCadastro() {
      this.cadastro = {
        tipo: null,
        valor: "",
        idCliente: "",
        motivo: "",
      };
      if (this.$refs.formCadastro) {
        this.$refs.formCadastro.resetValidation();
      }
    },

    montarPayloadCadastro() {
      const payload = {
        tipo: this.cadastro.tipo,
        valor: String(this.cadastro.valor).trim(),
      };
      if (this.cadastro.idCliente) {
        payload.idCliente = Number(this.cadastro.idCliente);
      }
      if (this.cadastro.motivo && String(this.cadastro.motivo).trim()) {
        payload.motivo = String(this.cadastro.motivo).trim();
      }
      return payload;
    },

    salvarItem() {
      if (!this.$refs.formCadastro.validate()) {
        return;
      }
      this.salvando = true;
      blacklist
        .salvar(this.montarPayloadCadastro())
        .then((response) => {
          this.exibirMensagem("Item cadastrado na blacklist com sucesso.");
          this.limparCadastro();
          this.carregarUltimos();
        })
        .catch((err) => {
          const msg =
            err.response?.data?.mensagem ||
            err.response?.data?.message ||
            "Não foi possível cadastrar o item.";
          this.exibirMensagem(msg, "error");
        })
        .finally(() => {
          this.salvando = false;
        });
    },

    selecionarRegistro(item) {
      this.registroSelecionado = item;
    },

    classeLinhaSelecionada(item) {
      return this.registroSelecionado &&
        this.registroSelecionado.id === item.id
        ? "linha-selecionada"
        : "";
    },

    abrirDialogStatus() {
      if (!this.registroSelecionado) {
        this.exibirMensagem("Selecione um registro na tabela.", "info");
        return;
      }
      this.abrirDialogStatusItem(this.registroSelecionado);
    },

    abrirDialogStatusItem(item) {
      this.registroStatus = item;
      this.registroSelecionado = item;
      this.statusAtivo = !item.dataExclusao;
      this.dialogStatus = true;
    },

    fecharDialogStatus() {
      this.dialogStatus = false;
      this.registroStatus = null;
    },

    confirmarAlterarStatus() {
      if (!this.registroStatus) {
        return;
      }
      this.alterandoStatus = true;
      blacklist
        .alterarStatus(this.registroStatus.id, this.statusAtivo)
        .then((response) => {
          const atualizado = response.data;
          this.atualizarRegistroNasListas(atualizado);
          this.exibirMensagem(
            this.statusAtivo
              ? "Registro reativado na blacklist."
              : "Registro inativado na blacklist."
          );
          this.fecharDialogStatus();
          if (!this.statusAtivo) {
            this.listaConsulta = this.listaConsulta.filter(
              (r) => r.id !== atualizado.id
            );
            this.registroSelecionado = null;
          }
          this.carregarUltimos();
        })
        .catch((err) => {
          const msg =
            err.response?.data?.mensagem ||
            err.response?.data?.message ||
            "Não foi possível alterar o status.";
          this.exibirMensagem(msg, "error");
        })
        .finally(() => {
          this.alterandoStatus = false;
        });
    },

    atualizarRegistroNasListas(registro) {
      const atualizar = (lista) =>
        lista.map((item) => (item.id === registro.id ? registro : item));
      this.listaConsulta = atualizar(this.listaConsulta);
      this.listaUltimos = atualizar(this.listaUltimos);
      if (
        this.registroSelecionado &&
        this.registroSelecionado.id === registro.id
      ) {
        this.registroSelecionado = registro;
      }
    },

    executarConsulta() {
      if (!this.$refs.formConsulta.validate()) {
        return;
      }
      this.registroSelecionado = null;
      this.consultando = true;
      const requisicao =
        this.modoConsulta === "cliente"
          ? blacklist.buscarPorCliente(Number(this.consulta.idCliente))
          : blacklist.buscarPorTipoValor(
              this.consulta.tipo,
              String(this.consulta.valor).trim()
            );

      requisicao
        .then((response) => {
          this.listaConsulta = response.data || [];
          if (!this.listaConsulta.length) {
            this.exibirMensagem("Nenhum registro encontrado.", "info");
          }
        })
        .catch(() => {
          this.exibirMensagem("Erro ao consultar a blacklist.", "error");
        })
        .finally(() => {
          this.consultando = false;
        });
    },

    carregarUltimos() {
      this.carregandoUltimos = true;
      blacklist
        .ultimos()
        .then((response) => {
          this.listaUltimos = response.data || [];
        })
        .catch(() => {
          this.exibirMensagem("Erro ao carregar os últimos registros.", "error");
        })
        .finally(() => {
          this.carregandoUltimos = false;
        });
    },
  },
};
</script>

<style scoped>
.cor-row {
  background-color: #f5f5f5;
}

>>> tbody tr.linha-selecionada {
  background-color: #e3f2fd !important;
}

>>> tbody tr {
  cursor: pointer;
}
</style>
